const handleOnChange = (props) => {
    const {
        changeFunction, e, preventDefault, boolean, parent,
        itemID, nestedProp, compareProp,
        isObject, objectProperty, validateNumeric,
        secondProp, secondPropDdlText, select, value, checkbox
    } = props;

    // Currently only handles properties two levels deep (don't currently have any deeper)
    if (preventDefault) {
        e.preventDefault();
    }

    let setVal;
    if (checkbox) {
        setVal = e.target.checked;
    } else if (!select) {
        setVal = e.target.value;
    } else {
        setVal = value;
    }


    if (boolean) {
        let boolVal
        boolVal = (setVal === "true" ? true : (setVal === 'false' ? false : null))
        setVal = boolVal
    }

    // console.log('my value', setVal)
    let secondVal;
    if (secondPropDdlText) {
        const inIndex = e.nativeEvent.target.selectedIndex;
        const inName = e.nativeEvent.target[inIndex].text;
        secondVal = inName
    }

    // Return and don't update value if value entered in numeric input is invalid or percent < 0 or > 100
    if (validateNumeric && !(setVal).match(/^-?([0-9]{0,})?(\.)?([0-9]{0,2})?$/)) { return }

    if (!isObject) {
        changeFunction(setVal)
    }
    else {
        if (parent && nestedProp) {
            // Update a nested property

            changeFunction((prevState) => ({
                ...prevState,
                [parent]: {
                    ...prevState[parent],
                    [objectProperty]: setVal,
                    ...secondProp && { [secondProp]: secondVal }
                },
            }));
        } else if (parent && itemID) {
            // Update value in nested array 
            changeFunction((prevState) => ({
                ...prevState,
                [parent]: prevState[parent].map((item) =>
                    itemID === item[compareProp]
                        ? { ...item, [objectProperty]: setVal }
                        : item
                ),
            }));
        } else {
            // Update a top-level property
            // console.log('should be here', setVal)
            changeFunction((prevState) => ({
                ...prevState,
                [objectProperty]: setVal,
            }));
        }
    }
};

const usStates = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

    // Function to sort data alphabetically by employee name
    function sortEmployees(employeeArray) {
        const sortedFirst = employeeArray.sort((a, b) => {
            if (a.FirstName_VC < b.FirstName_VC) {
                return -1;
            } else if (a.FirstName_VC > b.FirstName_VC) {
                return 1;
            } else {
                return 0
            }
        });
        const sortedData = sortedFirst.sort((a, b) => {
            if (a.LastName_VC < b.LastName_VC) {
                return -1;
            } else if (a.LastName_VC > b.LastName_VC) {
                return 1;
            } else {
                return 0
            }
        });
        return sortedData
    }

const FormUtilsFunctions = {
    handleOnChange,
    usStates,
    sortEmployees
}

export default FormUtilsFunctions;